class Lojas {
    constructor() {
        let buttonLoadMoreStores = document.querySelector('.load-more-stores');
        let containerResult = document.querySelector('.stores');

        //Load more stores
        let page = 1;
        if (buttonLoadMoreStores) {
            buttonLoadMoreStores.addEventListener('click', () => {

                let dataSearch = new FormData();

                dataSearch.append('action', 'get_nearby_locations');
                dataSearch.append('lat', document.querySelector('input[name="lat"]').value);
                dataSearch.append('lng', document.querySelector('input[name="lng"]').value);
                dataSearch.append('page', page);

                buttonLoadMoreStores.innerText = "CARREGANDO...";

                fetch(ajaxurl, {
                    method: 'POST',
                    body: dataSearch
                })
                    .then(response => {
                        response.json()
                            .then(data => {
                                console.log(data);

                                if (page >= data.total_pages) {
                                    buttonLoadMoreStores.innerText = "Todas as lojas foram carregadas";
                                    buttonLoadMoreStores.setAttribute('disabled', 'disabled');
                                } else {
                                    buttonLoadMoreStores.innerText = "Carregar mais lojas";
                                }

                                page++;

                                let template;
                                data.result.forEach(post => {
                                    template = `

                                    <div class="store">
                                        <div class="store-content">
                                            <div class="description">
                                                ${post.endereco_stores}, ${post.numero_stores}, ${post.complemento_stores}<br />
                                                ${post.bairro_stores}<br />
                                                ${post.cidade_stores}/${post.estado_stores}<br />
                                                CEP ${post.cep_stores}
                                            </div>
                                        </div>
                                    </div>
                                    `;

                                    containerResult.insertAdjacentHTML('beforeend', template);
                                });


                            });
                    });
            })
        }
    }
}

export default Lojas;